export { default as EventRegister } from './EventRegister';


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/libs/internal/index.js
// module id = 318
// module chunks = 0